import { Chip, TextField, Tooltip } from '@mui/material';
import React from 'react';

const userAutocompleteProps = {
  id: 'users-autocomplete-multiple',
  multiple: true,
  disableCloseOnSelect: true,
  renderInput: (params) => <TextField {...params} size="small" label="Пользователи" variant="outlined" />,
  renderTags: (value, getTagProps) =>
    value.map(({ appUserId, firstName, lastName, login }, index) => (
      <Tooltip key={appUserId} title={login || 'Нет данных'} placement="bottom-start" arrow>
        <Chip
          label={`${firstName} ${lastName}`}
          {...getTagProps({ index })}
          key={appUserId}
          color="primary"
          size="small"
          sx={{ margin: 0.5 }}
        />
      </Tooltip>
    )),
  getOptionLabel: (option) => `${option.firstName} ${option.lastName}`,
};

export default userAutocompleteProps;
